import axios from 'axios';
import { MessageBox } from 'element-ui';
import router from '../router';
import { clearAuth, getLanguage, getToken, getUserId } from '../store';
import { t } from '../i18n';

const request = axios.create({
  baseURL: process.env.API_HOST
});

request.interceptors.request.use(config => {
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  config.headers['X-AUTH-USER'] = getUserId();
  config.headers['X-AUTH-TOKEN'] = getToken();
  config.headers['X-Language'] = getLanguage();
  return config;
});

request.interceptors.response.use(
  response => {
    const data = response.data || {};
    if (data.status && data.status !== 0) {
      MessageBox.alert(data.msg || t('common.requestFailed'), t('common.error'), { type: 'error' });
    }
    return response;
  },
  err => {
    const status = err && err.response ? err.response.status : 0;
    const msg = err && err.response && err.response.data
      ? err.response.data.msg || t('common.requestFailed')
      : t('common.connectionFailed');
    if (status === 401 || status === 403) {
      clearAuth();
      MessageBox.alert(msg || t('common.requestFailed'), t('common.error'), { type: 'error' }).finally(() => {
        router.replace('/login');
      });
    } else {
      MessageBox.alert(msg, t('common.error'), { type: 'error' });
    }
    return Promise.reject(err);
  }
);

export default request;



// WEBPACK FOOTER //
// ./src/api/request.js